export default __webpack_public_path__ + "static/media/products.a4ed4224.svg";